import { render, staticRenderFns } from "./PaymentsFaqs.vue?vue&type=template&id=79207467&scoped=true&"
import script from "./PaymentsFaqs.vue?vue&type=script&lang=js&"
export * from "./PaymentsFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79207467",
  null
  
)

export default component.exports